// extracted by mini-css-extract-plugin
export default {"bodyContainer":"BodyContainer_bodyContainer__SEAjx"};